/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DateTrigger/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CalendarDate from 'DesignSystem/Svgs/Tysiav2CalendarDate/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DateTrigger({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/ScheduleOptions/Content/DateSelect/DateTrigger"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let tabSelectedDateValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.date',
})
let constantData = 'EEE, MMM dd, yyyy'
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let aggregateData = fromFormat.formatTzDate(tabSelectedDateValueData, constantData, tabSelectedTimeZoneIdValueData)
  return (<React.Fragment
>
<div
  data-testid="DateTrigger.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-28dA5i': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CalendarDate
  viewPath={`${viewPath}/Tysiav2CalendarDate`}
 width={12}
 height={12}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="small"
 data="tab.selected.date"
 data="'EEE, MMM dd, yyyy'"
 data="tab.selected.time_zone_id"
 aggregate="/Data/format.js formatTzDate"
 text={aggregateData}
/>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 height={14}
 width={14}
 fill={dtColorsNeutral400}
/>
</div>
{children}
</React.Fragment>)
}